<template>
	<validation-provider
		v-slot="{ errors }"
		:name="label"
		:rules="ruleString"
	>
		<v-text-field
			:is="tagName"
			ref="input"
			v-model.trim="model"
			:label="label"
			:required="required"
			:counter="counter"
			v-bind="$attrs"
			:error-messages="mergeError(errors)"
			:data-vv-name="label"
			:clearable="clearable&&!required"
			@change="$emit('change',model)"
		>
			<template #append>
				<v-icon
					v-if="required"
					x-small
					color="red lighten-2"
				>
					mdi-asterisk
				</v-icon>
			</template>
		</v-text-field>
	</validation-provider>
</template>

<script>
	export default {

		name: "smart-input",
		components: {},
		props: {
			label: { type: String },
			value: {},
			errors: {},
			name: { type: String },
			rules: { type: String },
			clearable: { type: Boolean, default: true },
			required: { type: Boolean },
			textarea: {
				type: Boolean, default: false,
			},
		},
		data () {
			return {};
		},
		computed: {
			type () {
				return this.$attrs.type || "text";
			},
			counter () {
				return (this.$attrs.maxlength) ? +this.$attrs.maxlength : null;
			},
			model: {
				get () {
					return this.value;
				},
				set (val) {
					this.$emit("input", val);
				},
			},
			theLabel () {
				return (this.required ? "* " : "") + this.label;
			},
			ruleString () {
				const rules = [];
				if (this.required) {
					rules.push("required");
				}
				if (this.type === "email") {
					rules.push("email");
				}
				const attrs = this.getAttrsRule(this.$attrs);
				if (attrs) {
					rules.push(attrs);
				}
				return rules.join("|");
			},
			tagName () {
				if (this.type === "checkbox") {
					return "v-checkbox";
				} else if (this.type === "radio") {
					return "v-radio";
				}
				return this.textarea ? "v-textarea" : "v-text-field";
			},

		},
		methods: {
			mergeError (errors) {
				if (this.errors) {
					if (Array.isArray(this.errors)) {
						return [...errors, ...this.errors];
					}
					return [...errors, this.errors];
				}
				return errors;
			},
			getAttrsRule (attrs) {
				const validAttrs = ["minlength", "maxlength", "min", "max"];
				const dic = { minlength: "min", maxlength: "max" };
				const numberDic = {
					minlength: "min",
					maxlength: "max",
					min: "min_value",
					max: "max_value",
				};
				const rules = [this.rules];
				Object.keys(attrs).forEach((rule) => {
					if (validAttrs.indexOf(rule) > -1) {
						let key = dic[rule] || rule;
						if (this.type === "number") {
							key = numberDic[rule] || rule;
						}
						rules.push(`${key}:${attrs[rule]}`);
					}
				});
				return rules.join("|");
			},
		},

	};
</script>
